module.exports = __webpack_public_path__ + "static/hero-home-a7ef60ce67b7b987d7edfa34d80a6928.webp";